import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "right-com"
  }, [_c("el-form", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.form.loading,
      expression: "form.loading"
    }],
    ref: "right-form",
    staticClass: "top-form",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      disabled: _vm.canEdit.isFlowCustomerManage ? true : !_vm.canEdit.isOwner,
      "label-position": "top"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "评价栏",
      prop: "evaluation"
    }
  }, [_c("el-radio-group", {
    attrs: {
      fill: "#1890FF"
    },
    model: {
      value: _vm.form.evaluation,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "evaluation", $$v);
      },
      expression: "form.evaluation"
    }
  }, _vm._l(_vm.evaluationOpt, function (item) {
    return _c("el-radio-button", {
      key: item.id,
      attrs: {
        label: item.id
      }
    }, [_vm._v(" " + _vm._s(item.label) + " ")]);
  }), 1)], 1), _vm.form.evaluation === 0 ? _c("el-form-item", {
    attrs: {
      prop: "intentionLevel"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c("span", [_vm._v("有效意向评价")]), _c("el-tooltip", {
          attrs: {
            placement: "right"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function fn() {
              return [_vm._v(" A：讲完流程到成交，和学员有沟通明确的报名时间和金额，需要跟进学员按时报名交钱。"), _c("br"), _vm._v(" B：讲完流程到报价，学员有意向报名，需要跟进确定具体报名时间和金额。"), _c("br"), _vm._v(" C：讲完流程到报价，学员有顾虑需解决或考虑，需要跟进确定报名意向。"), _c("br"), _vm._v(" D：客户想了解学历，电话已联系或微信已添加但未讲完流程。"), _c("br"), _vm._v(" E：客户想了解学历，电话或微信已联系上但未开始讲流程。"), _c("br")];
            },
            proxy: true
          }], null, false, 1888591044)
        }, [_c("i", {
          staticClass: "el-icon-question"
        })])];
      },
      proxy: true
    }], null, false, 31214832)
  }, [_c("el-rate", {
    attrs: {
      texts: _vm.intentionOpt,
      "show-text": ""
    },
    model: {
      value: _vm.form.intentionLevel,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "intentionLevel", $$v);
      },
      expression: "form.intentionLevel"
    }
  })], 1) : _vm._e(), _vm.form.evaluation === 1 ? _c("el-form-item", {
    staticClass: "tag-contianer",
    attrs: {
      label: "静默理由（提交此评价将会舍弃当前名片）",
      prop: "invalidTypeId"
    }
  }, [_c("el-radio-group", {
    model: {
      value: _vm.form.invalidTypeId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "invalidTypeId", $$v);
      },
      expression: "form.invalidTypeId"
    }
  }, _vm._l(_vm.invalidTypeOpt, function (item) {
    return _c("el-radio-button", {
      key: item.id,
      attrs: {
        label: item.id
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1) : _vm._e(), _vm.form.evaluation === 2 ? _c("el-form-item", {
    staticClass: "tag-contianer",
    attrs: {
      label: "联系未果",
      prop: "invalidTypeId"
    }
  }, [_c("el-radio-group", {
    model: {
      value: _vm.form.invalidTypeId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "invalidTypeId", $$v);
      },
      expression: "form.invalidTypeId"
    }
  }, _vm._l(_vm.contactNoResultOpt, function (item) {
    return _c("el-radio-button", {
      key: item.id,
      attrs: {
        label: item.id
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1) : _vm._e(), _c("el-form-item", {
    staticClass: "bottom-hr"
  }, [_c("template", {
    slot: "label"
  }, [_c("div", {
    staticClass: "user-tag-label"
  }, [_c("div", [_c("span", [_vm._v("用户标签")]), (_vm.canEdit.isFlowCustomerManage ? true : _vm.canEdit.isOwner) ? _c("i", {
    staticClass: "el-icon-edit-outline",
    on: {
      click: _vm.handleUserTag
    }
  }) : _vm._e()]), _c("div", {
    staticClass: "label-deepseek"
  }, [_vm._v("(已接入"), _c("img", {
    staticClass: "label-deepseek-img",
    attrs: {
      src: _vm.DeepseekTagIcon
    }
  }), _vm._v("-"), _c("span", {
    staticClass: "label-deepseek-eng"
  }, [_vm._v("V3/R1")]), _vm._v(")")])])]), _vm._l(_vm.crmLabel, function (item) {
    return _c("el-tag", {
      key: item,
      staticStyle: {
        "margin-right": "5px"
      },
      attrs: {
        effect: "plain",
        type: "danger"
      }
    }, [_vm._v(_vm._s(item))]);
  }), _vm._l(_vm.userTag.selectedTag, function (item) {
    return _c("el-tag", {
      key: item.id,
      staticStyle: {
        "margin-right": "5px"
      },
      attrs: {
        effect: "plain"
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), _vm._l(_vm.form.aiLabel, function (item) {
    return _c("ai-tag-com", {
      key: item.id,
      attrs: {
        "customer-id": _vm.cId,
        "customer-label": item,
        "ai-error-reason-opt": _vm.aiErrorReasonOpt
      },
      on: {
        refreshAiTag: function refreshAiTag($event) {
          return _vm.refreshAiTag(item.id);
        }
      }
    });
  }), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.formData.aiAdvice,
      expression: "formData.aiAdvice"
    }],
    staticClass: "right-form-tip"
  }, [_vm._v(" AI：" + _vm._s(_vm.form.aiAdvice) + " ")])], 2), _c("el-form-item", {
    attrs: {
      label: "跟进备注",
      prop: "remark"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 3,
      maxlength: 300,
      "show-word-limit": true,
      placeholder: "请输入备注信息"
    },
    model: {
      value: _vm.form.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "remark", $$v);
      },
      expression: "form.remark"
    }
  })], 1), _c("el-form-item", {
    staticClass: "btns"
  }, [_c("el-popover", {
    attrs: {
      trigger: "manual",
      placement: "top"
    },
    model: {
      value: _vm.confirm,
      callback: function callback($$v) {
        _vm.confirm = $$v;
      },
      expression: "confirm"
    }
  }, [_c("p", [_vm._v(_vm._s("\u68C0\u6D4B\u5230\u672C\u6B21\u63D0\u4EA4\u672A\u8FDB\u884C\u8BC4\u4EF7\u66F4\u6539\uFF0C\u5F53\u524D\u4E3A ".concat(_vm.evaluationName, "\uFF0C\u662F\u5426\u9700\u8981\u66F4\u6539\u8BC4\u4EF7")) + "？")]), _c("div", {
    staticStyle: {
      "text-align": "right",
      margin: "0"
    }
  }, [_c("el-button", {
    attrs: {
      size: "mini",
      type: "text"
    },
    on: {
      click: _vm.confirmSubmit
    }
  }, [_vm._v("不改，直接提交")]), _c("el-button", {
    attrs: {
      type: "primary",
      size: "mini"
    },
    on: {
      click: _vm.handleConfirmVisible
    }
  }, [_vm._v("改了再提交")])], 1), _c("el-button", {
    attrs: {
      slot: "reference",
      type: "primary",
      loading: _vm.submitLoading
    },
    on: {
      click: _vm.handleSubmit
    },
    slot: "reference"
  }, [_vm._v("提交")])], 1), _c("el-button", {
    on: {
      click: _vm.handleCancel
    }
  }, [_vm._v("取消")])], 1)], 1), _c("div", {
    staticClass: "right-com-clock"
  }, [_c("el-form", {
    ref: "bottom-form",
    staticClass: "bottom-form",
    attrs: {
      disabled: _vm.canEdit.isFlowCustomerManage ? true : !_vm.canEdit.isOwner,
      model: _vm.clock,
      rules: _vm.rules1,
      "label-position": "top"
    }
  }, [_c("el-form-item", {
    attrs: {
      prop: "revisitTime"
    }
  }, [_c("template", {
    slot: "label"
  }, [_c("span", {
    staticClass: "right-com-clock-label"
  }, [_vm._v("弹窗提醒闹钟")]), _c("el-switch", {
    attrs: {
      "active-value": 1,
      "inactive-value": 0
    },
    model: {
      value: _vm.clock.status,
      callback: function callback($$v) {
        _vm.$set(_vm.clock, "status", $$v);
      },
      expression: "clock.status"
    }
  })], 1), _c("div", {
    staticClass: "clock"
  }, [_c("el-date-picker", {
    attrs: {
      type: "datetime",
      "picker-options": _vm.pickerOptions,
      placeholder: "请选择回访时间",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: _vm.clock.revisitTime,
      callback: function callback($$v) {
        _vm.$set(_vm.clock, "revisitTime", $$v);
      },
      expression: "clock.revisitTime"
    }
  }), _c("el-button", {
    attrs: {
      type: "text",
      size: "mini",
      loading: _vm.clock.loading
    },
    on: {
      click: _vm.handleSaveClock
    }
  }, [_vm._v(" 保存 ")])], 1)], 2)], 1)], 1), _c("user-tag-com", {
    attrs: {
      "edit-data": _vm.userTag
    },
    on: {
      selectedTag: _vm.newTag,
      close: _vm.handleUserTag
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };